<template>
    <div class="static-wheel">
        <WebpImage class="static-wheel__construction" :src="wheelConfig.assets.wheelConstruction" alt="" />

        <WebpImage class="static-wheel__outside" :src="lightsOutsideSrc" alt="" />

        <WebpImage
            v-if="enableAnimation"
            class="static-wheel__pointer"
            :src="props.wheelConfig.assets.wheelConstructionPointer"
            alt=""
        />

        <div class="static-wheel__rotation-content">
            <WebpImage
                alt=""
                :src="props.wheelConfig.assets.wheelPins"
                class="spinning-wheel__rotation-image spinning-wheel__rotation-image--pins"
            />
        </div>

        <button
            v-if="showLogoAsButton"
            disabled
            class="spinning-wheel__construction-middle spinning-wheel__spin-button"
            :class="{ 'spinning-wheel__spin-button--error-state': isErrorState }"
        >
            <WebpImage
                v-if="wheelConfig.assets?.buttonGlints?.small"
                :src="wheelConfig.assets.buttonGlints.small"
                cssClass="spinning-wheel__spin-button-glint spinning-wheel__spin-button-glint--sm"
                alt="Furry Spin - odlesk tlačítka"
            />
            <WebpImage
                v-if="wheelConfig.assets?.buttonGlints?.large"
                :src="wheelConfig.assets.buttonGlints.large"
                cssClass="spinning-wheel__spin-button-glint spinning-wheel__spin-button-glint--lg"
                alt="Furry Spin - odlesk tlačítka"
            />
            <WebpImage class="static-wheel__logo-in-btn" :src="props.wheelConfig.assets.staticLogo" alt="" />
        </button>
        <WebpImage v-else class="static-wheel__logo" :src="props.wheelConfig.assets.staticLogo" alt="" />

        <div v-if="logoBubbleText" class="wheel-speech-bubble wheel-speech-bubble--active-container">
            <div class="wheel-speech-bubble__tail"></div>
            <div class="wheel-speech-bubble__content">{{ logoBubbleText }}</div>
        </div>

        <WebpImage
            class="static-wheel__inside"
            :src="wheelInsideSrc"
            alt=""
            :class="enableAnimation ? 'static-wheel__inside--spin' : ''"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { CanvasConfiguration } from "../spinning-wheel//models/sw-configuration";

const props = defineProps<{
    wheelConfig: CanvasConfiguration;
    enableAnimation?: boolean;
    disabled?: boolean;
    showLogoAsButton?: boolean;
    logoBubbleText?: string;
    isErrorState?: boolean;
}>();

const lightsOutsideSrc = computed(() =>
    props.enableAnimation ? props.wheelConfig.assets.lightsOutside.on : props.wheelConfig.assets.lightsOutside.off
);

const wheelInsideSrc = computed(() =>
    props.disabled ? props.wheelConfig.assets.staticInsideDisabled : props.wheelConfig.assets.staticInsideOn
);
</script>
